import { EmployeeSelect, EMPLOYEE_UNASSIGNED } from "@/components/employee-select";
import { useAssignableTechnicians } from "@/features/service/hooks";

export const TECHNICIAN_UNASSIGNED = EMPLOYEE_UNASSIGNED;

interface TechnicianSelectProps {
  value: string;
  onChange: (value: string) => void;
}

// TechnicianSelect is the assignment dropdown for work orders and service
// schedules. Options come from the roster: active Service-department
// employees.
export function TechnicianSelect({ value, onChange }: TechnicianSelectProps) {
  const { data: assignableTechnicians = [] } = useAssignableTechnicians();
  return (
    <EmployeeSelect
      value={value}
      onChange={onChange}
      options={assignableTechnicians}
      emptyHint="No Service employees in roster"
    />
  );
}
